
export default {
    availableCaseTypes: [],
}